
// export const logout = ( state ) => {
// }

export const setInputdetails = (state, inputdetails) => {
    state.inputdetails = inputdetails
}

export const setInputdetailsSelectable = (state, inputdetails) => {
    state.inputdetailsSelectable = inputdetails
}

export const setInputdetailsPaginated = (state, inputdetailsPaginatedData) => {
    state.inputdetailsPaginatedData = inputdetailsPaginatedData
}

export const setInputdetail = (state, inputdetail) => {
    state.inputdetail = inputdetail
}

export const saveNewInputdetails = (state, inputdetail) => {
    // state.inputdetails.unshift(inputdetail)
    state.createdData = inputdetail;
}

export const saveUpdatedInputdetail = (state, inputdetail) => {
    // state.inputdetails.unshift(inputdetail)
    state.updatedData = inputdetail;
}

export const setDeleteInputdetail = (state, inputdetail) => {
    state.deletedData = inputdetail
}

export const setInputdetailIsLoading = (state, isLoading) => {
    state.isLoading = isLoading
}

export const setInputdetailIsCreating = (state, isCreating) => {
    state.isCreating = isCreating
}

export const setInputdetailIsUpdating = (state, isUpdating) => {
    state.isUpdating = isUpdating
}

export const setInputdetailIsDeleting = (state, isDeleting) => {
    state.isDeleting = isDeleting
}

export const setInputdetailIsSelecting = (state, isSelecting) => {
    state.isSelecting = isSelecting
}

export const setSelectedListInputdetail = (state, inputdetails) => {
    state.selectedListData = inputdetails
}